import { render } from "./MigrationInfoNotice.vue?vue&type=template&id=377ab8da"
const script = {}

import "./MigrationInfoNotice.vue?vue&type=style&index=0&id=377ab8da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__